// Turn Markdown into clean plain text for chat channels; keeps line structure and list bullets.
export const stripMarkdown = (md = '') =>
  md
    .replace(/```[a-z]*\n?([\s\S]*?)```/g, '$1')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1 ($2)')
    .replace(/^\s{0,3}#{1,6}\s+/gm, '')
    .replace(/^\s{0,3}>\s?/gm, '')
    .replace(/^\s*[-*+]\s+/gm, '• ')
    .replace(/^\s*(\d+)[.)]\s+/gm, '$1. ')
    .replace(/(\*\*|__)(.*?)\1/g, '$2')
    .replace(/(^|[\s(])[*_]([^*_\n]+)[*_](?=[\s).,!?:;]|$)/g, '$1$2')
    .replace(/~~(.*?)~~/g, '$1')
    .replace(/^\s*[-*_]{3,}\s*$/gm, '')
    .replace(/^\|?\s*:?-{2,}:?\s*(\|\s*:?-{2,}:?\s*)*\|?\s*$/gm, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

export const SHARE_ANSWER_MAX_CHARS = 4000;

export const buildShareText = ({ modelName, userName, question, answer }) => {
  const header = `AI answer (${modelName || 'ChatGPT'}) shared by ${userName || 'a teammate'}`;
  const q = (question || '').replace(/\s+/g, ' ').trim();
  const quoted = q ? `❝ ${q.length > 200 ? `${q.slice(0, 200).trimEnd()}…` : q} ❞` : '';
  let body = stripMarkdown(answer);
  if (body.length > SHARE_ANSWER_MAX_CHARS) body = `${body.slice(0, SHARE_ANSWER_MAX_CHARS).trimEnd()}…\n\n(Full answer is in the AI chat.)`;
  return [header, quoted, body].filter(Boolean).join('\n');
};

const escapeRe = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const SKIP_SEGMENTS = /(\[[^\]]*\]\([^)]*\)|```[\s\S]*?```|`[^`]*`)/g;

// Link the first plain mention of each task title to #task:<id> (longest titles first; existing links and code are left alone).
export const linkTaskTitles = (md = '', tasks = []) => {
  let out = md;
  [...tasks].sort((a, b) => (b.title || '').length - (a.title || '').length).forEach((t) => {
    if (!t.title || t.title.length < 4) return;
    const re = new RegExp(escapeRe(t.title), 'i');
    const parts = out.split(SKIP_SEGMENTS);
    for (let i = 0; i < parts.length; i += 2) {
      if (re.test(parts[i])) {
        parts[i] = parts[i].replace(re, (m) => `[${m}](#task:${t.id})`);
        break;
      }
    }
    out = parts.join('');
  });
  return out;
};
